// HowItWorks.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./CheckInLanding.css";

const steps = [
    {
        n: "01",
        t: "Set the timer",
        d: "Take a minute to set up your account",
    },
    {
        n: "02",
        t: "Choose contacts",
        d: "Choose up to three emergency contacts",
    },
    {
        n: "03",
        t: "Live your life",
        d: "Choose your check-in frequency",
    },
    {
        n: "04",
        t: "Tap to confirm",
        d: "Let Keep in Touch do the rest",
    },
];

const HowItWorks = () => {
    return (
        <section className="how-section" id="how-it-works">
            <Container>

                <div className="how-top">
                    <div>
                        <p className="how-label">— How Keep in Touch Works</p>

                        <h2 className="how-title">
                            Four steps. <em>Zero stress.</em>
                        </h2>
                    </div>

                    <p className="how-desc">
                        When it’s time for your check-in, we’ll send you a simple email or text. If you confirm through the
                        app that you’re okay, nothing happens. If you don’t respond, we’ll send an alert to your loved
                        ones
                    </p>
                </div>

                <Row className="g-0 how-grid">
                    {steps.map((item, index) => (
                        <Col lg={3} sm={6} className="p-0" key={index}>
                            <div className="how-card">
                                <div className="how-number">{item.n}</div>
                                <h4>{item.t}</h4>
                                <p>{item.d}</p>
                            </div>
                        </Col>
                    ))}
                </Row>

            </Container>
        </section>
    );
};

export default HowItWorks;